import { STATUS_PENDING, STATUS_SUCCESS, STATUS_FAILURE, STATUS_RESET } from 'Common/constants/commonConstants';
import * as RemoteExecutionConstants from './RemoteExecutionConstants';

const initialState = {
  status:         STATUS_RESET,
  successMessage: '',
  errorMessage:   '',
  jobId:          '',
};

const RemoteExecutionReducer = (state = initialState, action) => {
  switch (action.type) {
    case RemoteExecutionConstants.FLEET_COMMAND_REQUEST:
      return {
        ...state,
        status:         STATUS_PENDING,
        successMessage: '',
        errorMessage:   '',
      };

    case RemoteExecutionConstants.FLEET_COMMAND_SUCCESS:
      return {
        ...state,
        status:         STATUS_SUCCESS,
        jobId:          action.payload.jobId   || '',
        successMessage: action.payload.message || RemoteExecutionConstants.MSG_COMMAND_SUCCESS,
        errorMessage:   '',
      };

    case RemoteExecutionConstants.FLEET_COMMAND_FAILURE:
      return {
        ...state,
        status:         STATUS_FAILURE,
        errorMessage:   action.payload,
        successMessage: '',
      };

    case RemoteExecutionConstants.FLEET_COMMAND_RESET:
      return initialState;

    default:
      return state;
  }
};

export default RemoteExecutionReducer;
